// import { authSagas } from "../Views/Authentication/Auth.watchers";
import {authSagas} from '../Views/Authentication/Auth.watchers'
import { all } from "redux-saga/effects";

export default function* rootSaga(){
    yield all([authSagas()])
}